export default {
  pt: {
    pageTitle: "Central de Ajuda",
    understoodButton: "Entendi",
    reportButton: "Reportar problema",
    coverageText: "Coberturas e exclusões",
    safetyText: "Dicas de segurança",
    detailsText: "Detalhes do programa",
    faqText: "Dúvidas frequentes",
    claimText: "Aviso de sinistro",
    whatsappText: "WhatsApp",
  },

  en: {
    pageTitle: "Help Center",
    understoodButton: "I understand",
    reportButton: "Report problem",
    coverageText: "Coverages and exclusions",
    safetyText: "Safety tips",
    detailsText: "Program details",
    faqText: "Frequently asked questions",
    claimText: "Loss notice",
    whatsappText: "WhatsApp",
  },
}; 